import React, { useEffect, useState } from 'react';
import useDsInquiry from '../hook/useDsInquiry';
import useQuery from '../../../util/useQuery';
import { Form, Select, Table } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { tagStatusColor } from './Tab1';

export default function Tab2({ setDepartmentId, setStatusId }) {
    const { t, i18n } = useTranslation();

    const { hash } = useLocation();
    const params = useQuery();
    const [form] = Form.useForm();
    const [allValues, setAllValues] = useState({
        status: 'all',
        department: 'all',
    });

    const [pagevalue, setPagevalue] = useState({
        p: 1,
        ps: 10,
        s: '',
        sd: '',
        total: 0,
    });

    const {
        statusRopa,
        department,
        dataflowRopa,
        loadingDetail,
        getRopa,
        getDataSubject,
    } = useDsInquiry(setPagevalue);

    useEffect(() => {
        getDataSubject();
    }, [getDataSubject]);

    useEffect(() => {
        const payload = {
            dataSubjectIds: params.get('id'),
            statusId: '',
            departmentId: '',
            ...pagevalue,
        };
        delete payload.total;
        if (payload.dataSubjectIds && hash === '#ropa') {
            getRopa(payload);
        }
        form.setFieldValue({
            status: 'all',
            department: 'all',
        });
        resetAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getRopa, params.get('id'), hash]);

    const resetAll = () => {
        form.resetFields();
        setAllValues({
            status: 'all',
            department: 'all',
        });
        form.setFieldValue({
            status: 'all',
            department: 'all',
        });
        setDepartmentId('');
        setStatusId('');
    };

    useEffect(() => {
        resetAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash]);

    const onValuesChange = (_, allValues) => {
        const statusId = allValues.status === 'all' ? '' : allValues.status;
        const departmentId =
            allValues.department === 'all' ? '' : allValues.department;
        const payload = {
            dataSubjectIds: params.get('id'),
            statusId,
            departmentId,
            ...pagevalue,
        };
        delete payload.total;
        setAllValues(allValues);
        getRopa(payload);
        setDepartmentId(departmentId);
        setStatusId(statusId);
    };

    const columns_dataflow = [
        {
            title: 'RoPA',
            dataIndex: 'activityName',
            key: 'activityName',
            width: '50%',
        },
        {
            title: t('Status'),
            dataIndex: 'statusEn',
            key: 'statusEn',
            render: (statusEn, record) => (
                <div
                    style={{
                        border: `1px solid ${tagStatusColor(statusEn)}`,
                    }}
                    className={`text-[${tagStatusColor(
                        statusEn
                    )}] rounded-full w-max text-[12px] px-2`}
                >
                    {i18n.language === 'en' ? statusEn : record.statusTh}
                </div>
            ),
        },
        {
            title: t('Department'),
            dataIndex: 'departmentEn',
            key: 'departmentEn',
            render: (departmentEn, record) => (
                <div>
                    {i18n.language === 'en'
                        ? departmentEn
                        : record.departmentTh}
                </div>
            ),
        },
    ];

    const paginationProps = {
        current: parseInt(pagevalue.p),
        // pageSize: 10,
        total: parseInt(pagevalue.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination) => {
        const payload = {
            dataSubjectIds: params.get('id'),
            statusId: allValues?.status === 'all' ? '' : allValues?.status,
            departmentId:
                allValues?.department === 'all' ? '' : allValues?.department,
            p: pagination.current,
            ps: pagination.pageSize,
        };
        delete payload.total;
        getRopa(payload);
    };

    return (
        <div className="font-semibold bg-white">
            {t('Related RoPA', { count: pagevalue.total })}
            <Form
                layout="vertical"
                form={form}
                className="pt-4 grid grid-cols-2 gap-2"
                onValuesChange={onValuesChange}
                initialValues={{
                    status: 'all',
                    department: 'all',
                }}
            >
                <FormItem label={t('Status')} name="status" className="mb-2">
                    <Select size="large" options={statusRopa} />
                </FormItem>
                <FormItem label={t('Department')} name="department">
                    <Select size="large" options={department} />
                </FormItem>
            </Form>
            <Table
                className="inbox_table"
                rowKey={(record) => record.activityId}
                loading={loadingDetail}
                dataSource={dataflowRopa}
                columns={columns_dataflow}
                pagination={paginationProps}
                onChange={onPageChange}
            />
        </div>
    );
}
